// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css */
.sidebar {
  width: 300px;
  height: 100vh;
  background: var(--bg-primary, #ffffff);
  border-right: 1px solid var(--border-light, #e5e7eb);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  overflow: hidden;
  transition: width 0.3s ease;
}

/* Collapsed state */
.sidebar.collapsed {
  width: 70px;
}

/* Dark theme support */
.dark .sidebar {
  background: var(--bg-primary-dark, #1f2937);
  border-right-color: var(--border-dark, #374151);
}

/* Toggle Button - Matches User Menu Style */
.sidebar-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-secondary, #6b7280);
  transition: all 0.2s ease;
}

.sidebar-toggle:hover {
  background: var(--bg-secondary, #f3f4f6);
  color: var(--text-primary, #111827);
}

.dark .sidebar-toggle:hover {
  background: var(--bg-secondary-dark, #374151);
  color: var(--text-primary-dark, #f9fafb);
}

/* Toggle button as collapsed user avatar replacement */
.collapsed-toggle-avatar {
  width: 40px;
  height: 40px;
  background: var(--primary-color, #3b82f6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.collapsed-toggle-avatar:hover {
  background: var(--primary-color-hover, #2563eb);
  transform: scale(1.05);
}

/* Header Section */
.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid var(--border-light, #e5e7eb);
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.sidebar.collapsed .sidebar-header {
  padding: 20px 10px;
}

.dark .sidebar-header {
  border-bottom-color: var(--border-dark, #374151);
}

/* Collapsed Header */
.collapsed-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.collapsed-user-avatar {
  width: 40px;
  height: 40px;
  background: var(--primary-color, #3b82f6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.collapsed-new-chat {
  width: 40px;
  height: 40px;
  background: var(--primary-color, #3b82f6);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.collapsed-new-chat:hover {
  background: var(--primary-color-hover, #2563eb);
  transform: scale(1.1);
}

.user-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: var(--primary-color, #3b82f6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.user-details {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.user-name {
  font-weight: 600;
  color: var(--text-primary, #111827);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark .user-name {
  color: var(--text-primary-dark, #f9fafb);
}

.user-email {
  font-size: 12px;
  color: var(--text-secondary, #6b7280);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark .user-email {
  color: var(--text-secondary-dark, #9ca3af);
}

/* User Menu */
.user-menu-container {
  position: relative;
}

.user-menu-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-secondary, #6b7280);
  transition: all 0.2s ease;
}

.user-menu-button:hover {
  background: var(--bg-secondary, #f3f4f6);
  color: var(--text-primary, #111827);
}

.dark .user-menu-button:hover {
  background: var(--bg-secondary-dark, #374151);
  color: var(--text-primary-dark, #f9fafb);
}

.user-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: var(--bg-primary, #ffffff);
  border: 1px solid var(--border-light, #e5e7eb);
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  padding: 8px;
  min-width: 150px;
  z-index: 200;
}

.dark .user-menu {
  background: var(--bg-primary-dark, #1f2937);
  border-color: var(--border-dark, #374151);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.user-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  width: 100%;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-primary, #111827);
  transition: background-color 0.2s ease;
}

.dark .user-menu-item {
  color: var(--text-primary-dark, #f9fafb);
}

.user-menu-item:hover {
  background: var(--bg-secondary, #f3f4f6);
}

.dark .user-menu-item:hover {
  background: var(--bg-secondary-dark, #374151);
}

.user-menu-item.sign-out {
  color: #ef4444;
}

.user-menu-item.sign-out:hover {
  background: #fef2f2;
}

.dark .user-menu-item.sign-out:hover {
  background: #7f1d1d;
}

/* New Chat Row (button + clear-all icon) */
.new-chat-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

/* New Chat Button */
.new-chat-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex: 1 1;
  padding: 12px 16px;
  background: var(--primary-color, #3b82f6);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Clear All Chats Button — matches .new-chat-icon-btn dimensions */
.clear-all-chats-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  padding: 0;
  background: transparent;
  color: #ef4444;
  border: 1px solid rgba(239, 68, 68, 0.35);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, transform 0.12s ease;
}

.clear-all-chats-btn:hover:not(:disabled) {
  background: #ef4444;
  color: #ffffff;
  border-color: #ef4444;
  transform: translateY(-1px);
}

.clear-all-chats-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
}

[data-theme="dark"] .clear-all-chats-btn {
  color: #f87171;
  border-color: rgba(248, 113, 113, 0.4);
}

[data-theme="dark"] .clear-all-chats-btn:hover:not(:disabled) {
  background: #ef4444;
  color: #ffffff;
  border-color: #ef4444;
}

.new-chat-button:hover {
  background: var(--primary-color-hover, #2563eb);
  transform: translateY(-1px);
}

/* Search Section */
.sidebar-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-light, #e5e7eb);
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.sidebar-search .search-container {
  flex: 1 1;
}

.new-chat-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border: none;
  border-radius: 8px;
  background: #2663EB;
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.new-chat-icon-btn:hover {
  background: #1d4fc4;
  transform: translateY(-1px);
}

.new-chat-icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.dark .sidebar-search {
  border-bottom-color: var(--border-dark, #374151);
}

.search-container {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary, #6b7280);
}

.search-input {
  width: 100%;
  padding: 10px 12px 10px 36px;
  border: 1px solid var(--border-light, #e5e7eb);
  border-radius: 8px;
  background: var(--bg-secondary, #f9fafb);
  color: var(--text-primary, #111827);
  font-size: 14px;
  transition: all 0.2s ease;
}

.dark .search-input {
  border-color: var(--border-dark, #374151);
  background: var(--bg-secondary-dark, #374151);
  color: var(--text-primary-dark, #f9fafb);
}

.search-input:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-input::placeholder {
  color: var(--text-secondary, #6b7280);
}

.dark .search-input::placeholder {
  color: var(--text-secondary-dark, #9ca3af);
}

/* Chat Sessions */
.chat-sessions {
  flex: 1 1;
  overflow-y: auto;
  padding: 0 20px 20px;
  transition: padding 0.3s ease;
}

.sidebar.collapsed .chat-sessions {
  padding: 0 10px 20px;
}

.loading-sessions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: var(--text-secondary, #6b7280);
  gap: 12px;
}

.sidebar.collapsed .loading-sessions {
  padding: 40px 5px;
}

.dark .loading-sessions {
  color: var(--text-secondary-dark, #9ca3af);
}

.loading-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid var(--border-light, #e5e7eb);
  border-top: 2px solid var(--primary-color, #3b82f6);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.dark .loading-spinner {
  border-color: var(--border-dark, #374151);
  border-top-color: var(--primary-color, #3b82f6);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.no-sessions {
  text-align: center;
  padding: 40px 20px;
  color: var(--text-secondary, #6b7280);
  font-size: 14px;
}

.sidebar.collapsed .no-sessions {
  padding: 40px 5px;
}

.dark .no-sessions {
  color: var(--text-secondary-dark, #9ca3af);
}

.sessions-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}

/* Session Item */
.session-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  group: true;
}

.session-item.collapsed {
  justify-content: center;
  padding: 12px 8px;
}

.session-item:hover {
  background: var(--bg-secondary, #f3f4f6);
  border-color: var(--border-light, #e5e7eb);
}

.dark .session-item:hover {
  background: var(--bg-secondary-dark, #374151);
  border-color: var(--border-dark, #4b5563);
}

.session-item.active {
  background: rgba(59, 130, 246, 0.1);
  border-color: var(--primary-color, #3b82f6);
}

.dark .session-item.active {
  background: rgba(59, 130, 246, 0.2);
  border-color: var(--primary-color, #3b82f6);
}

.session-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

.session-item.collapsed .session-content {
  justify-content: center;
  flex: none;
}

.session-icon {
  color: var(--text-secondary, #6b7280);
  flex-shrink: 0;
}

.dark .session-icon {
  color: var(--text-secondary-dark, #9ca3af);
}

.session-item.active .session-icon {
  color: var(--primary-color, #3b82f6);
}

.session-details {
  flex: 1 1;
  min-width: 0;
}

.session-title {
  font-weight: 500;
  color: var(--text-primary, #111827);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.dark .session-title {
  color: var(--text-primary-dark, #f9fafb);
}

.session-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--text-secondary, #6b7280);
}

.dark .session-meta {
  color: var(--text-secondary-dark, #9ca3af);
}

.session-date::after {
  content: "•";
  margin-left: 8px;
}

.new-chat-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.collapsed-new-chat:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.loading-sessions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  color: var(--text-secondary);
  font-size: 14px;
}

.loading-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--border-color);
  border-top: 2px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Style for creating new chat state */
.new-chat-button span {
  transition: all 0.2s ease;
}

.new-chat-button:disabled span {
  opacity: 0.7;
}

/* Ensure active session remains highlighted during creation */
.session-item.active {
  background-color: var(--primary-color);
  color: white;
  border-radius: 8px;
}

.session-menu-button {
  opacity: 0;
  padding: 6px;
  border: none;
  background: none;
  border-radius: 4px;
  cursor: pointer;
  color: var(--text-secondary, #6b7280);
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.session-item:hover .session-menu-button {
  opacity: 1;
}

.session-menu-button:hover {
  background: var(--bg-tertiary, #f3f4f6);
  color: #ef4444;
}

.dark .session-menu-button:hover {
  background: var(--bg-tertiary-dark, #4b5563);
}

/* Sidebar Footer */
.sidebar-footer {
  flex-shrink: 0;
  padding: 20px;
  border-top: 1px solid var(--border-light, #e5e7eb);
  background: var(--bg-primary, #ffffff);
}

.dark .sidebar-footer {
  border-top-color: var(--border-dark, #374151);
  background: var(--bg-primary-dark, #1f2937);
}

.sidebar-neon-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  color: var(--text-primary, #111827);
  text-decoration: none;
  font-size: 28px;
  font-weight: bold;
  transition: opacity 0.2s ease;
}

.sidebar-neon-link:hover {
  opacity: 0.8;
}

.dark .sidebar-neon-link {
  color: var(--text-primary-dark, #f9fafb);
}

.sidebar-neon-logo {
  height: 1em;
  width: auto;
  flex-shrink: 0;
}

.sidebar-copyright-text {
  margin: 8px 0 0 0;
  font-size: 10px;
  line-height: 1.4;
  color: var(--text-secondary, #6b7280);
}

.dark .sidebar-copyright-text {
  color: var(--text-secondary-dark, #9ca3af);
}

.sidebar-patents-link {
  color: var(--text-secondary, #6b7280);
  text-decoration: underline;
}

.dark .sidebar-patents-link {
  color: var(--text-secondary-dark, #9ca3af);
}

.sidebar-footer.collapsed .sidebar-neon-link {
  justify-content: center;
}

.sidebar-footer.collapsed .sidebar-neon-logo {
  height: 28px;
}

/* Tooltip for collapsed state */
.session-item.collapsed {
  position: relative;
}

.mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 150;
  display: none;
}

.mobile-sidebar-overlay.visible {
  display: block;
}

.session-item.collapsed:hover::after {
  content: attr(title);
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  background: var(--bg-primary, #ffffff);
  border: 1px solid var(--border-light, #e5e7eb);
  border-radius: 6px;
  padding: 8px 12px;
  margin-left: 8px;
  white-space: nowrap;
  font-size: 12px;
  color: var(--text-primary, #111827);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark .session-item.collapsed:hover::after {
  background: var(--bg-primary-dark, #1f2937);
  border-color: var(--border-dark, #374151);
  color: var(--text-primary-dark, #f9fafb);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.sidebar-canvas-btn {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 13px 20px;
  background: linear-gradient(180deg, #7B7BF0 0%, #5957E8 100%);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.005em;
  margin-top: 14px;
  margin-bottom: 8px;
  box-shadow:
    0 0 32px -10px rgba(99, 102, 241, 0.45),
    0 4px 14px -4px rgba(89, 87, 232, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.18);
  transition:
    transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    background 0.25s ease;
}

/* Sliding shimmer that sweeps across on hover */
.sidebar-canvas-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.25) 50%,
    transparent 100%
  );
  transition: left 0.6s ease;
  pointer-events: none;
}

.sidebar-canvas-btn > * {
  position: relative;
  z-index: 1;
}

.sidebar-canvas-btn svg {
  color: #ffffff;
  flex-shrink: 0;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-canvas-btn:hover {
  transform: translateY(-2px) scale(1.015);
  background: linear-gradient(180deg, #8C8CF7 0%, #6663EE 100%);
  box-shadow:
    0 0 80px -8px rgba(124, 124, 240, 0.85),
    0 12px 28px -6px rgba(89, 87, 232, 0.7),
    inset 0 1px 0 rgba(255, 255, 255, 0.32);
}

.sidebar-canvas-btn:hover::before {
  left: 100%;
}

.sidebar-canvas-btn:hover svg {
  transform: rotate(-8deg) scale(1.1);
}

.sidebar-canvas-btn:active {
  transform: translateY(0) scale(1);
  transition-duration: 0.1s;
}

.sidebar.collapsed .sidebar-canvas-btn span {
  display: none;
}

.sidebar.collapsed .sidebar-canvas-btn {
  justify-content: center;
  padding: 12px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sidebar {
    width: 280px;
    transform: translateX(-100%);
    transition: transform 0.3s ease, width 0.3s ease;
    z-index: 200; /* Higher z-index for mobile */
  }
  
  .sidebar.collapsed {
    width: 70px;
    transform: translateX(-100%); /* Keep hidden when collapsed on mobile */
  }
  
  .sidebar.mobile-open {
    transform: translateX(0);
  }

  .mobile-sidebar-overlay.visible {
    display: block;
  }
}

.sidebar-version {
  padding: 8px 16px;
  border-top: 1px solid var(--border-light, #e5e7eb);
  font-size: 11px;
  color: var(--text-secondary, #6b7280);
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
}

.sidebar.collapsed .sidebar-version {
  padding: 8px 4px;
  font-size: 10px;
}

.dark .sidebar-version {
  border-top-color: var(--border-dark, #374151);
  color: var(--text-secondary-dark, #9ca3af);
}`, "",{"version":3,"sources":["webpack://./src/styles/Sidebar.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,oDAAoD;EACpD,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qDAAqD;EACrD,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAO;EACP,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,kGAAkG;AACpG;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,8CAA8C;EAC9C,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,mDAAmD;EACnD,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,8DAA8D;AAC9D;EACE,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,aAAa;EACb,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,2CAA2C;EAC3C,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB;;;2CAGyC;EACzC;;;yBAGuB;AACzB;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,wCAAwC;EACxC,6DAA6D;EAC7D;;;2CAGyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,4BAA4B;IAC5B,gDAAgD;IAChD,YAAY,EAAE,8BAA8B;EAC9C;;EAEA;IACE,WAAW;IACX,4BAA4B,EAAE,yCAAyC;EACzE;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,0CAA0C;AAC5C","sourcesContent":["/* Sidebar.css */\n.sidebar {\n  width: 300px;\n  height: 100vh;\n  background: var(--bg-primary, #ffffff);\n  border-right: 1px solid var(--border-light, #e5e7eb);\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 100;\n  overflow: hidden;\n  transition: width 0.3s ease;\n}\n\n/* Collapsed state */\n.sidebar.collapsed {\n  width: 70px;\n}\n\n/* Dark theme support */\n.dark .sidebar {\n  background: var(--bg-primary-dark, #1f2937);\n  border-right-color: var(--border-dark, #374151);\n}\n\n/* Toggle Button - Matches User Menu Style */\n.sidebar-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  background: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--text-secondary, #6b7280);\n  transition: all 0.2s ease;\n}\n\n.sidebar-toggle:hover {\n  background: var(--bg-secondary, #f3f4f6);\n  color: var(--text-primary, #111827);\n}\n\n.dark .sidebar-toggle:hover {\n  background: var(--bg-secondary-dark, #374151);\n  color: var(--text-primary-dark, #f9fafb);\n}\n\n/* Toggle button as collapsed user avatar replacement */\n.collapsed-toggle-avatar {\n  width: 40px;\n  height: 40px;\n  background: var(--primary-color, #3b82f6);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.collapsed-toggle-avatar:hover {\n  background: var(--primary-color-hover, #2563eb);\n  transform: scale(1.05);\n}\n\n/* Header Section */\n.sidebar-header {\n  padding: 20px;\n  border-bottom: 1px solid var(--border-light, #e5e7eb);\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.sidebar.collapsed .sidebar-header {\n  padding: 20px 10px;\n}\n\n.dark .sidebar-header {\n  border-bottom-color: var(--border-dark, #374151);\n}\n\n/* Collapsed Header */\n.collapsed-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.collapsed-user-avatar {\n  width: 40px;\n  height: 40px;\n  background: var(--primary-color, #3b82f6);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n}\n\n.collapsed-new-chat {\n  width: 40px;\n  height: 40px;\n  background: var(--primary-color, #3b82f6);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.collapsed-new-chat:hover {\n  background: var(--primary-color-hover, #2563eb);\n  transform: scale(1.1);\n}\n\n.user-section {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.user-avatar {\n  width: 36px;\n  height: 36px;\n  background: var(--primary-color, #3b82f6);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.user-name {\n  font-weight: 600;\n  color: var(--text-primary, #111827);\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dark .user-name {\n  color: var(--text-primary-dark, #f9fafb);\n}\n\n.user-email {\n  font-size: 12px;\n  color: var(--text-secondary, #6b7280);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dark .user-email {\n  color: var(--text-secondary-dark, #9ca3af);\n}\n\n/* User Menu */\n.user-menu-container {\n  position: relative;\n}\n\n.user-menu-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  background: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--text-secondary, #6b7280);\n  transition: all 0.2s ease;\n}\n\n.user-menu-button:hover {\n  background: var(--bg-secondary, #f3f4f6);\n  color: var(--text-primary, #111827);\n}\n\n.dark .user-menu-button:hover {\n  background: var(--bg-secondary-dark, #374151);\n  color: var(--text-primary-dark, #f9fafb);\n}\n\n.user-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: var(--bg-primary, #ffffff);\n  border: 1px solid var(--border-light, #e5e7eb);\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  padding: 8px;\n  min-width: 150px;\n  z-index: 200;\n}\n\n.dark .user-menu {\n  background: var(--bg-primary-dark, #1f2937);\n  border-color: var(--border-dark, #374151);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);\n}\n\n.user-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  width: 100%;\n  border: none;\n  background: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--text-primary, #111827);\n  transition: background-color 0.2s ease;\n}\n\n.dark .user-menu-item {\n  color: var(--text-primary-dark, #f9fafb);\n}\n\n.user-menu-item:hover {\n  background: var(--bg-secondary, #f3f4f6);\n}\n\n.dark .user-menu-item:hover {\n  background: var(--bg-secondary-dark, #374151);\n}\n\n.user-menu-item.sign-out {\n  color: #ef4444;\n}\n\n.user-menu-item.sign-out:hover {\n  background: #fef2f2;\n}\n\n.dark .user-menu-item.sign-out:hover {\n  background: #7f1d1d;\n}\n\n/* New Chat Row (button + clear-all icon) */\n.new-chat-row {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  width: 100%;\n}\n\n/* New Chat Button */\n.new-chat-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex: 1;\n  padding: 12px 16px;\n  background: var(--primary-color, #3b82f6);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n/* Clear All Chats Button — matches .new-chat-icon-btn dimensions */\n.clear-all-chats-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  padding: 0;\n  background: transparent;\n  color: #ef4444;\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, transform 0.12s ease;\n}\n\n.clear-all-chats-btn:hover:not(:disabled) {\n  background: #ef4444;\n  color: #ffffff;\n  border-color: #ef4444;\n  transform: translateY(-1px);\n}\n\n.clear-all-chats-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  transform: none;\n}\n\n[data-theme=\"dark\"] .clear-all-chats-btn {\n  color: #f87171;\n  border-color: rgba(248, 113, 113, 0.4);\n}\n\n[data-theme=\"dark\"] .clear-all-chats-btn:hover:not(:disabled) {\n  background: #ef4444;\n  color: #ffffff;\n  border-color: #ef4444;\n}\n\n.new-chat-button:hover {\n  background: var(--primary-color-hover, #2563eb);\n  transform: translateY(-1px);\n}\n\n/* Search Section */\n.sidebar-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-light, #e5e7eb);\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n}\n\n.sidebar-search .search-container {\n  flex: 1;\n}\n\n.new-chat-icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  border: none;\n  border-radius: 8px;\n  background: #2663EB;\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.new-chat-icon-btn:hover {\n  background: #1d4fc4;\n  transform: translateY(-1px);\n}\n\n.new-chat-icon-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.dark .sidebar-search {\n  border-bottom-color: var(--border-dark, #374151);\n}\n\n.search-container {\n  position: relative;\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary, #6b7280);\n}\n\n.search-input {\n  width: 100%;\n  padding: 10px 12px 10px 36px;\n  border: 1px solid var(--border-light, #e5e7eb);\n  border-radius: 8px;\n  background: var(--bg-secondary, #f9fafb);\n  color: var(--text-primary, #111827);\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.dark .search-input {\n  border-color: var(--border-dark, #374151);\n  background: var(--bg-secondary-dark, #374151);\n  color: var(--text-primary-dark, #f9fafb);\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--primary-color, #3b82f6);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.search-input::placeholder {\n  color: var(--text-secondary, #6b7280);\n}\n\n.dark .search-input::placeholder {\n  color: var(--text-secondary-dark, #9ca3af);\n}\n\n/* Chat Sessions */\n.chat-sessions {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 20px 20px;\n  transition: padding 0.3s ease;\n}\n\n.sidebar.collapsed .chat-sessions {\n  padding: 0 10px 20px;\n}\n\n.loading-sessions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  color: var(--text-secondary, #6b7280);\n  gap: 12px;\n}\n\n.sidebar.collapsed .loading-sessions {\n  padding: 40px 5px;\n}\n\n.dark .loading-sessions {\n  color: var(--text-secondary-dark, #9ca3af);\n}\n\n.loading-spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid var(--border-light, #e5e7eb);\n  border-top: 2px solid var(--primary-color, #3b82f6);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.dark .loading-spinner {\n  border-color: var(--border-dark, #374151);\n  border-top-color: var(--primary-color, #3b82f6);\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.no-sessions {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--text-secondary, #6b7280);\n  font-size: 14px;\n}\n\n.sidebar.collapsed .no-sessions {\n  padding: 40px 5px;\n}\n\n.dark .no-sessions {\n  color: var(--text-secondary-dark, #9ca3af);\n}\n\n.sessions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n/* Session Item */\n.session-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n  group: true;\n}\n\n.session-item.collapsed {\n  justify-content: center;\n  padding: 12px 8px;\n}\n\n.session-item:hover {\n  background: var(--bg-secondary, #f3f4f6);\n  border-color: var(--border-light, #e5e7eb);\n}\n\n.dark .session-item:hover {\n  background: var(--bg-secondary-dark, #374151);\n  border-color: var(--border-dark, #4b5563);\n}\n\n.session-item.active {\n  background: rgba(59, 130, 246, 0.1);\n  border-color: var(--primary-color, #3b82f6);\n}\n\n.dark .session-item.active {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: var(--primary-color, #3b82f6);\n}\n\n.session-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n.session-item.collapsed .session-content {\n  justify-content: center;\n  flex: none;\n}\n\n.session-icon {\n  color: var(--text-secondary, #6b7280);\n  flex-shrink: 0;\n}\n\n.dark .session-icon {\n  color: var(--text-secondary-dark, #9ca3af);\n}\n\n.session-item.active .session-icon {\n  color: var(--primary-color, #3b82f6);\n}\n\n.session-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.session-title {\n  font-weight: 500;\n  color: var(--text-primary, #111827);\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 2px;\n}\n\n.dark .session-title {\n  color: var(--text-primary-dark, #f9fafb);\n}\n\n.session-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--text-secondary, #6b7280);\n}\n\n.dark .session-meta {\n  color: var(--text-secondary-dark, #9ca3af);\n}\n\n.session-date::after {\n  content: \"•\";\n  margin-left: 8px;\n}\n\n.new-chat-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.collapsed-new-chat:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.loading-sessions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px;\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.loading-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--border-color);\n  border-top: 2px solid var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Style for creating new chat state */\n.new-chat-button span {\n  transition: all 0.2s ease;\n}\n\n.new-chat-button:disabled span {\n  opacity: 0.7;\n}\n\n/* Ensure active session remains highlighted during creation */\n.session-item.active {\n  background-color: var(--primary-color);\n  color: white;\n  border-radius: 8px;\n}\n\n.session-menu-button {\n  opacity: 0;\n  padding: 6px;\n  border: none;\n  background: none;\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--text-secondary, #6b7280);\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.session-item:hover .session-menu-button {\n  opacity: 1;\n}\n\n.session-menu-button:hover {\n  background: var(--bg-tertiary, #f3f4f6);\n  color: #ef4444;\n}\n\n.dark .session-menu-button:hover {\n  background: var(--bg-tertiary-dark, #4b5563);\n}\n\n/* Sidebar Footer */\n.sidebar-footer {\n  flex-shrink: 0;\n  padding: 20px;\n  border-top: 1px solid var(--border-light, #e5e7eb);\n  background: var(--bg-primary, #ffffff);\n}\n\n.dark .sidebar-footer {\n  border-top-color: var(--border-dark, #374151);\n  background: var(--bg-primary-dark, #1f2937);\n}\n\n.sidebar-neon-link {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  color: var(--text-primary, #111827);\n  text-decoration: none;\n  font-size: 28px;\n  font-weight: bold;\n  transition: opacity 0.2s ease;\n}\n\n.sidebar-neon-link:hover {\n  opacity: 0.8;\n}\n\n.dark .sidebar-neon-link {\n  color: var(--text-primary-dark, #f9fafb);\n}\n\n.sidebar-neon-logo {\n  height: 1em;\n  width: auto;\n  flex-shrink: 0;\n}\n\n.sidebar-copyright-text {\n  margin: 8px 0 0 0;\n  font-size: 10px;\n  line-height: 1.4;\n  color: var(--text-secondary, #6b7280);\n}\n\n.dark .sidebar-copyright-text {\n  color: var(--text-secondary-dark, #9ca3af);\n}\n\n.sidebar-patents-link {\n  color: var(--text-secondary, #6b7280);\n  text-decoration: underline;\n}\n\n.dark .sidebar-patents-link {\n  color: var(--text-secondary-dark, #9ca3af);\n}\n\n.sidebar-footer.collapsed .sidebar-neon-link {\n  justify-content: center;\n}\n\n.sidebar-footer.collapsed .sidebar-neon-logo {\n  height: 28px;\n}\n\n/* Tooltip for collapsed state */\n.session-item.collapsed {\n  position: relative;\n}\n\n.mobile-sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 150;\n  display: none;\n}\n\n.mobile-sidebar-overlay.visible {\n  display: block;\n}\n\n.session-item.collapsed:hover::after {\n  content: attr(title);\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  background: var(--bg-primary, #ffffff);\n  border: 1px solid var(--border-light, #e5e7eb);\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin-left: 8px;\n  white-space: nowrap;\n  font-size: 12px;\n  color: var(--text-primary, #111827);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dark .session-item.collapsed:hover::after {\n  background: var(--bg-primary-dark, #1f2937);\n  border-color: var(--border-dark, #374151);\n  color: var(--text-primary-dark, #f9fafb);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.sidebar-canvas-btn {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  padding: 13px 20px;\n  background: linear-gradient(180deg, #7B7BF0 0%, #5957E8 100%);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 999px;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: -0.005em;\n  margin-top: 14px;\n  margin-bottom: 8px;\n  box-shadow:\n    0 0 32px -10px rgba(99, 102, 241, 0.45),\n    0 4px 14px -4px rgba(89, 87, 232, 0.45),\n    inset 0 1px 0 rgba(255, 255, 255, 0.18);\n  transition:\n    transform 0.25s cubic-bezier(0.4, 0, 0.2, 1),\n    box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1),\n    background 0.25s ease;\n}\n\n/* Sliding shimmer that sweeps across on hover */\n.sidebar-canvas-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent 0%,\n    rgba(255, 255, 255, 0.25) 50%,\n    transparent 100%\n  );\n  transition: left 0.6s ease;\n  pointer-events: none;\n}\n\n.sidebar-canvas-btn > * {\n  position: relative;\n  z-index: 1;\n}\n\n.sidebar-canvas-btn svg {\n  color: #ffffff;\n  flex-shrink: 0;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar-canvas-btn:hover {\n  transform: translateY(-2px) scale(1.015);\n  background: linear-gradient(180deg, #8C8CF7 0%, #6663EE 100%);\n  box-shadow:\n    0 0 80px -8px rgba(124, 124, 240, 0.85),\n    0 12px 28px -6px rgba(89, 87, 232, 0.7),\n    inset 0 1px 0 rgba(255, 255, 255, 0.32);\n}\n\n.sidebar-canvas-btn:hover::before {\n  left: 100%;\n}\n\n.sidebar-canvas-btn:hover svg {\n  transform: rotate(-8deg) scale(1.1);\n}\n\n.sidebar-canvas-btn:active {\n  transform: translateY(0) scale(1);\n  transition-duration: 0.1s;\n}\n\n.sidebar.collapsed .sidebar-canvas-btn span {\n  display: none;\n}\n\n.sidebar.collapsed .sidebar-canvas-btn {\n  justify-content: center;\n  padding: 12px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 280px;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease, width 0.3s ease;\n    z-index: 200; /* Higher z-index for mobile */\n  }\n  \n  .sidebar.collapsed {\n    width: 70px;\n    transform: translateX(-100%); /* Keep hidden when collapsed on mobile */\n  }\n  \n  .sidebar.mobile-open {\n    transform: translateX(0);\n  }\n\n  .mobile-sidebar-overlay.visible {\n    display: block;\n  }\n}\n\n.sidebar-version {\n  padding: 8px 16px;\n  border-top: 1px solid var(--border-light, #e5e7eb);\n  font-size: 11px;\n  color: var(--text-secondary, #6b7280);\n  text-align: center;\n  user-select: none;\n  flex-shrink: 0;\n}\n\n.sidebar.collapsed .sidebar-version {\n  padding: 8px 4px;\n  font-size: 10px;\n}\n\n.dark .sidebar-version {\n  border-top-color: var(--border-dark, #374151);\n  color: var(--text-secondary-dark, #9ca3af);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
